module.exports = __webpack_public_path__ + "media/images/phone/app-download-banner-screen-65bb4ce169f403b08eca6247091d8c90.png";